import { render, staticRenderFns } from "./CurrentTreatmentCard.vue?vue&type=template&id=15e7ab3f&scoped=true"
import script from "./CurrentTreatmentCard.vue?vue&type=script&lang=js"
export * from "./CurrentTreatmentCard.vue?vue&type=script&lang=js"
import style0 from "./CurrentTreatmentCard.vue?vue&type=style&index=0&id=15e7ab3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e7ab3f",
  null
  
)

export default component.exports